import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useAppDispatch, useAppSelector } from "app/store";
import { Button, Tooltip, ClickAwayListener } from "@material-ui/core";
import {
  closeModalAttachment,
  selectStateModalAtt,
} from "app/store/trackingApp/modalAttachmentSlice";
import InfoSvg from "./infoSvg";
import { Main, Overlay, Btn, ContentModal } from "./styles";
import ItemSvg from "./ItemSvg";
import TrackingUtils from "@tracking/utils/TrackingUtils";
import getEnv from "env";

const REACT_APP_VIATRACKING_SERVICE_NOW_URL = getEnv(
  "REACT_APP_VIATRACKING_SERVICE_NOW_URL"
);

interface ItemProps {
  isArchived: boolean;
  fileName: string;
  _handleView: () => any;
  _handleDownload: () => any;
}

const formatFileName = (name: string) => {
  let newName = name;
  if (name.length > 20) {
    newName = name.substr(0, 20) + "...";
  }
  return newName;
};

const Item: React.FC<ItemProps> = (props) => {
  const { isArchived, fileName, _handleView, _handleDownload } = props;
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(fileName);
      handleTooltipOpen();
    } catch (err: any) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div className="w-auto h-fit flex mx-12 gap-x-7 justify-between">
      <div className="flex">
        <ItemSvg />{" "}
        <Tooltip
          title={isArchived ? "" : "Clique para visualizar o comprovante"}
          placement="top"
        >
          <p
            className={`ml-3 mb-0 ${
              !isArchived ? "underline cursor-pointer" : ""
            }`}
            onClick={!isArchived ? _handleView : undefined}
          >
            {" "}
            {formatFileName(fileName)}{" "}
          </p>
        </Tooltip>
      </div>
      {isArchived && (
        <>
          <p className="font-bold">Arquivado</p>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <div>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                placement="bottom"
                title="Copiado para a área de transferência"
              >
                <p className="cursor-pointer" onClick={copyToClipboard}>
                  {" "}
                  Copiar <FileCopyIcon color="primary" className="text-xl" />
                </p>
              </Tooltip>
            </div>
          </ClickAwayListener>
        </>
      )}
      {!isArchived && (
        <p className="cursor-pointer" onClick={_handleDownload}>
          {" "}
          Baixar <CloudDownloadIcon color="primary" className="text-xl" />
        </p>
      )}
    </div>
  );
};

const ModalAttachment: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectStateModalAtt);
  const { attachments, openPreview } = state.content;

  const itemsArchiveds = attachments
    ? attachments.some((item) => item.archived === true)
    : false;

  const _handleClose = () => dispatch(closeModalAttachment());

  return (
    <>
      {state.open && (
        <>
          <Main className="fixed bg-white flex justify-center flex-wrap z-20 p-7">
            <CloseIcon
              onClick={_handleClose}
              className="absolute top-2 right-2 text-xl cursor-pointer"
              style={{ color: "#000" }}
            />
            <div
              className="bg-gray-50 flex justify-center"
              style={{ width: 436, borderRadius: "8px" }}
            >
              <InfoSvg />
            </div>
            <p className="w-full text-center font-bold text-2xl my-4 flex items-center justify-center gap-1 title-modal">
              <InfoIcon />
              Atenção
            </p>
            <p className="text-center px-8">
              Esse pedido possui {attachments.length} anexos:
            </p>
            {itemsArchiveds && (
              <p className="text-center px-8">
                Pedido possui comprovantes com data de origem acima de 1 ano
                <br />
                <span className="font-bold">
                  Para ter acesso copie o arquivo e abra o chamado no service
                  now e cole no campo 'Descrição'
                </span>
              </p>
            )}
            <div className="mt-7 flex flex-wrap justify-center">
              <ContentModal className="w-full grid h-64 gap-6 overflow-y-auto">
                {attachments &&
                  attachments.length > 0 &&
                  attachments.map(
                    (
                      item: {
                        file_name: string;
                        url: string;
                        archived: boolean;
                      },
                      index: React.Key | null | undefined
                    ) => {
                      return (
                        <Item
                          isArchived={item.archived}
                          fileName={item.file_name}
                          key={index}
                          _handleDownload={() =>
                            TrackingUtils.downloadAtt(item.url, item.file_name)
                          }
                          _handleView={() => openPreview(item)}
                        />
                      );
                    }
                  )}
              </ContentModal>
              <div className="flex items-center justify-around w-full">
                {itemsArchiveds && (
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    href={REACT_APP_VIATRACKING_SERVICE_NOW_URL}
                    target="_blank"
                  >
                    Abrir Chamado
                  </Button>
                )}
                <Btn onClick={_handleClose} className="border-solid border" label="Abrir em nova aba">
                  Fechar
                </Btn>
              </div>
            </div>
          </Main>
          <Overlay
            className="fixed w-full h-full z-10 top-0 left-0"
            onClick={_handleClose}
          />
        </>
      )}
    </>
  );
};

export default ModalAttachment;
